module.exports = __webpack_public_path__ + "img/Alternatives scoping-Impact characterisation.2a6e527a.svg";